export const roleCodes = {
  admin: 'admin',
  guest: 'guest',
  user: 'user',
}

export const roleIds = {
  1: 'owner',
  2: 'admin',
  3: 'member',
}

export const organizationPermissionCodes = {
  organizationManageEdit: 'edit',
  organizationManageMedal: 'organization-manage-medal',
  organizationManageEvent: 'organization-manage-event',
  organizationManageChannel: 'organization-manage-channel',
  organizationManageArticle: 'organization-manage-article',
  organizationManageMember: 'organization-manage-member',
  organizationManageInfo: 'organization-manage-info',
  organizationManageDelete: 'organization-manage-delete',
  organizationManageRole: 'organization-manage-role',
  organizationManagePermission: 'organization-manage-permission',
  organizationManageStructure: 'organization-manage-structure',
  organizationManagePeerStructure: 'organization-manage-peer-structure',
}

export const permissionCodes = {
  canPost: 'can_post',
  canInvite: 'canInvite',
  canJoin: 'canJoin',
  canSubscribe: 'canSubscribe',
  canBookmark: 'canBookmark',
  canPostArticle: 'canPostArticle',
  canCopy_link: 'canCopy_link',
  canDelete: 'canDelete',
  canEdit: 'canEdit',
  canMessage: 'canMessage',
  canRemove: 'canRemove',
  canShare: 'canShare',
  canTo: 'canTo',
  canView: 'canView',
  canVote: 'canVote',
}
